var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeprecatedVisibilityOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3905 0.879395C4.70448 0.879395 1.55661 3.1721 0.28125 6.40843C1.55661 9.64476 4.70448 11.9375 8.3905 11.9375C12.0765 11.9375 15.2244 9.64476 16.4998 6.40843C15.2244 3.1721 12.0765 0.879395 8.3905 0.879395ZM8.3905 10.0945C6.35582 10.0945 4.70448 8.44312 4.70448 6.40843C4.70448 4.37375 6.35582 2.72241 8.3905 2.72241C10.4252 2.72241 12.0765 4.37375 12.0765 6.40843C12.0765 8.44312 10.4252 10.0945 8.3905 10.0945ZM8.3905 4.19682C7.16674 4.19682 6.17889 5.18467 6.17889 6.40843C6.17889 7.63219 7.16674 8.62005 8.3905 8.62005C9.61426 8.62005 10.6021 7.63219 10.6021 6.40843C10.6021 5.18467 9.61426 4.19682 8.3905 4.19682Z",
    fill: "#9C9C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeprecatedVisibilityOnIcon);
export default __webpack_public_path__ + "static/media/DeprecatedVisibilityOnIcon.e9efffaf9ba511362b4087a8e12ccbb6.svg";
export { ForwardRef as ReactComponent };